import { IETFLanguageTag } from '@ancon/wildcat-types'

import { SupportedLanguage } from '../constants'

// Get IETF tag
export default function getLocaleTag(locale?: string): string {
  switch (locale) {
    case SupportedLanguage.English:
      return IETFLanguageTag.English

    case SupportedLanguage.Norwegian:
      return IETFLanguageTag.Norwegian

    default:
      return IETFLanguageTag.Swedish
  }
}
